import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import communityInfoFragment from 'shared/graphql/fragments/community/communityInfo';
import communityMemberInfoFragment from '../../fragments/communityMember/communityMemberInfo';

export const getCommunityRoleMembersQuery = gql`
  query getCommunityRoleMembers($id: ID) {
    community(id: $id) {
      ...communityInfo
      roleMembers {
        ...communityMemberInfo
      }
    }
  }
  ${communityInfoFragment}
  ${communityMemberInfoFragment}
`;

const getCommunityRoleMembersOptions = {
  options: ({ id }) => ({
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  }),
};

export default graphql(
  getCommunityRoleMembersQuery,
  getCommunityRoleMembersOptions
);
